import {COUNTRIES, COUNTRY} from './env';

const DICTIONARY = ['TOBACCO', 'ALCOHOL', 'MEDICATIONS', 'VETERINARY', 'DRINKS'] as const;

export const ProductGroupsMap: Record<COUNTRIES, typeof DICTIONARY[number][]> = {
    CAR: ['TOBACCO', 'ALCOHOL', 'MEDICATIONS', 'VETERINARY', 'DRINKS'],
    NG: ['TOBACCO', 'ALCOHOL', 'MEDICATIONS'],
    TJ: ['TOBACCO', 'ALCOHOL', 'MEDICATIONS'],
};

export const ProductGroups = Object.fromEntries(
    ProductGroupsMap[COUNTRY ?? 'CAR'].map((c) => [c, c] as const),
) as Record<ProductGroup, ProductGroup>;
export type ProductGroup = typeof DICTIONARY[number];
